import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "../../actions/EmailAuthenticationActions";
import ServerError from "../common/ServerError";
import { loginSteps } from "../../utilities/Constants";
import SoleSourceTitle from "newApp/controls/SoleSourceTitle";
import { PendingButton } from "@p1s/p1s-common-react";
import CheckMark from "newApp/controls/CheckMark";
import ticketType from "newApp/entities/TicketType";

export class PasswordResetSent extends Component {
    constructor (props) {
        super(props);
    }

    componentDidMount() {
        this.props.getTicketExpirationPeriod(true, ticketType.virtualUser.resetPassword.id);
    }

    onResendEmail = () => {
        this.props.resendEmail(this.props.email);
    }

    render () {
        const serverError = this.props.serverError;
        const hasServerError = serverError && serverError != null && serverError.length > 0;
        const expirationPeriod = this.props.expirationPeriod;

        if (this.props.step !== loginSteps.passwordResetSent)
            return null;

        return (
            <div>
                <SoleSourceTitle />

                <div id="passwordResetSent">

                    <div className="form-title"><span className="lock-reset password-reset-icon"/>Password Reset</div>
                    <div className="linked-email">{this.props.email}</div>
                    {
                        !this.props.isResetEmailSent && <div className="row-link">
                            <PendingButton
                                title="Send Password Reset Link"
                                pendingTitle="Sending"
                                isPending={this.props.isResetEmailSendButtonPending}
                                onClick={this.onResendEmail}/>
                        </div>
                    }
                    {
                        this.props.isResetEmailSent && <div className="form-subtitle">

                            <CheckMark visible={true} isChecked={true} label="Password Reset Sent"/>
                            <br/>
                            This link is valid for {expirationPeriod}. If you’re having trouble finding the email, try the
                            following:
                            <ul>
                                <li>Check your Spam folder</li>
                                <li>Add @wolterskluwer.com domain to the safe sender list, this likely will require
                                    assistance from your IT team
                                </li>
                            </ul>
                            If after 5 minutes, the email still hasn’t arrived, please call support at
                            <br/>(800) 341-0450
                            or email cscsupport@wolterskluwer.com
                            <br/><br/>
                        </div>
                    }
                    <div className="row-link">
                        <a className="link" name='backToPassword' onClick={this.props.backToPasswordForm}>Back to password screen</a>
                    </div>

                    <ServerError
                        errorSummary={"Send Email Failed"}
                        serverError={serverError}
                        isVisible={hasServerError}/>
                </div>
            </div>);
    }
}

PasswordResetSent.propTypes = {
    email: PropTypes.string,
    serverError: PropTypes.string,
    step: PropTypes.string,
    resendEmail: PropTypes.func,
    backToPasswordForm: PropTypes.func,
    getTicketExpirationPeriod: PropTypes.func,
    isResetEmailSendButtonPending: PropTypes.bool,
    isResetEmailSent: PropTypes.bool,
    expirationPeriod: PropTypes.string
};

const mapStateToProps = state => ({
    email: state.loginState.email,
    serverError: state.loginState.loginFailure,
    step: state.loginState.loginStep,
    isResetEmailSendButtonPending: state.emailLoginState.isResetEmailSending,
    isResetEmailSent: state.emailLoginState.isResetEmailSent,
    expirationPeriod: state.linkExpiredState.expirationPeriod
});

const mapDispatchToProps = (dispatch) => {
    return ({
        resendEmail: (email) => dispatch(actions.resendResetPasswordLink(email)),
        backToPasswordForm: () => dispatch(actions.backToPasswordForm()),
        getTicketExpirationPeriod: (isVirtualUser, type) => dispatch(actions.getTicketExpirationPeriod(isVirtualUser, type))
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(PasswordResetSent);
